import { z } from 'zod';

export const LOGO_NAMES = z.enum([
  'apple-pay',
  'compassion',
  'compassion-explorer',
  'compassion-journey',
  'compassion-moments',
  'compassion-simple',
  'compassion-sunday',
  'compassion-experience',
  'skippy',
  'compassion-accelerators',
  'compassion-accelerators-text',
  'compassion-advocacy-partners',
  'compassion-called-to-care',
  'compassion-giving-tuesday',
  'compassion-multipliers',
  'compassion-multipliers-text',
  'compassion-nurturers',
  'compassion-nurturers-text',
  'compassion-responders',
  'compassion-responders-text',
  'compassion-unto-jesus',
  'k-m-circle',
  'practicing-the-way',
  'trust-charity-watch',
  'trust-ecfa',
  'trust-bbb',
  'trust-guide-star',
  'trust-charity-navigator',
  'trust-norton',
  'trust-seal-of-transparency-guide-star',
]);

export type LogoName = z.infer<typeof LOGO_NAMES>;
